// apps/web/src/features/admin/form-config/hooks/useFieldValidator.ts
import { useMemo } from 'react';
import { validateContent, isValidContentShape, type ValidationError } from '@capture/shared';
import { useFormConfigStore } from '../state/store';

export interface ValidatorResult {
  errors: Map<string, ValidationError[]>;
  errorCount: number;
  warnCount: number;
  canPublish: boolean;
}

export function useFieldValidator(): ValidatorResult {
  const content = useFormConfigStore((s) => s.content);

  return useMemo(() => {
    if (!isValidContentShape(content)) {
      return { errors: new Map(), errorCount: 0, warnCount: 0, canPublish: false };
    }
    const all = validateContent(content);
    const errors = new Map<string, ValidationError[]>();
    let errorCount = 0, warnCount = 0;
    for (const e of all) {
      const key = e.behaviorId ?? e.fieldName ?? e.path.join('.');
      const arr = errors.get(key) ?? [];
      arr.push(e);
      errors.set(key, arr);
      if (e.severity === 'error') errorCount++; else warnCount++;
    }
    return { errors, errorCount, warnCount, canPublish: errorCount === 0 };
  }, [content]);
}
